import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { getDayList, getWeekNameList } from "components/ui/Calendar";
import Slider from "components/ui/Slider";
import { getCalendar, getDateAdd } from "utils/date";

export const Week = (props) => {
  const self = useRef();
  const getStartDate = (date) => {
    date = date ? new Date(date) : new Date();
    const weekIndex = date.getDay();
    date.setDate(date.getDate() - weekIndex);
    return getCalendar(date);
  };
  const today = getCalendar();
  const [date, setDate] = useState(getStartDate(props.date));
  const [value, setValue] = useState(props.value || today);

  useEffect(() => {
    eventHandler.update();
  }, []);

  useEffect(() => {
    if (props.date) {
      const newDate = getStartDate(props.date);
      if (date != newDate) setDate(newDate);
    }
  }, [props.date]);

  useEffect(() => {
    if (props.value != value) {
      const newDate = getStartDate(props.value);
      if (date != newDate) setDate(newDate);
      setValue(props.value);
    }
  }, [props.value]);

  const eventHandler = {
    update: (eventInfo) => {
      let direction = 0;
      if (eventInfo) {
        direction = eventInfo.direction;
        setDate((date) => {
          return getDateAdd(date, 0, 0, 7 * direction);
        });
      }
      if (props.onUpdate) {
        const searchDate = getDateAdd(date, 0, 0, 7 * direction);
        const startDate = searchDate;
        const endDate = getDateAdd(searchDate, 0, 0, 6);
        props.onUpdate(props.name, startDate, endDate);
      }
    },
    changeValue: (event) => {
      let newValue = event.currentTarget.getAttribute("data-date");
      if (newValue == value) return;
      // newValue = (value == newValue) ? "" : newValue;
      setValue(newValue);
      if (props.onChange) {
        const startDate = date;
        const endDate = getDateAdd(date, 0, 0, 7);
        props.onChange(props.name, newValue);
      }
    },
  };

  const render = () => {
    const getHead = () => {
      const weekList = getWeekNameList();
      const li = weekList.map((item, index) => {
        return <li key={index}>{item}</li>;
      });
      return <ul className="week">{li}</ul>;
    };

    const getBody = (index) => {
      const getDate = () => {
        const dateList = [
          getDateAdd(date, 0, 0, -7),
          date,
          getDateAdd(date, 0, 0, 7),
        ];
        if (self.current) {
          const li = self.current.querySelectorAll("li[data-index]");
          for (let i = 0; i < 3; i++) {
            if (Number(li[i].getAttribute("data-index")) == index) {
              return dateList[i];
            }
          }
        } else {
          return dateList[index];
        }
      };
      const searchDate = getDate();
      const dateList = getDayList(searchDate);

      const li = [];
      dateList.forEach((item, index) => {
        const className = [];
        if (item.isNone) className.push("none");
        if (item.isToday) className.push("today");
        if (item.isHoliday) className.push("holiday");
        if (item.date == value) className.push("selected");
        li.push(
          <li key={item.date} className={className.join(" ")}>
            <a
              onClick={eventHandler.changeValue}
              data-date={item.date}
              title={item.holidayName}
            >
              <span>{item.day}</span>
            </a>
            {props.onRender ? (
              <div className="info">{props.onRender(item) || "-"}</div>
            ) : null}
          </li>
        );
      });
      return <ul className="week">{li}</ul>;
    };

    const getClassName = () => {
      const classList = props.className ? props.className.split(" ") : [];
      if (props.import) classList.push("import");
      return classList.join(" ");
    };

    return (
      <Wrapper ref={self} className={getClassName()}>
        <div className="top">{getHead()}</div>
        <div className="middle">
          <Slider isLoop={true} onChange={eventHandler.update}>
            <ul>
              <li data-index="0">{getBody(0)}</li>
              <li data-index="1">{getBody(1)}</li>
              <li data-index="2">{getBody(2)}</li>
            </ul>
          </Slider>
        </div>
      </Wrapper>
    );
  };

  return render();
};

const Wrapper = styled.div`
  & {
    padding: 10px 12px 8px 12px;
    background-color: white;
    border-radius: var(--borderRadius);
    border: 1px solid var(--border);
  }
  &.import {
    padding: 0;
    border-radius: 0;
    border: none;
  }

  .week {
    display: flex;
    background-color: white;
    text-align: center;
  }
  .week li {
    display: flex;
    width: 100%;
    justify-content: center;
    flex-flow: wrap;
  }
  .week li a {
    display: inline-flex;
    width: 2.334em;
    height: 2.334em;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 1px solid transparent;
  }
  .week li:first-child {
    color: #fa7575;
  }
  .week li:last-child {
    color: #6d88e9;
  }
  .week li.today span {
    color: var(--blue);
  }
  .week li.selected a {
    background-color: var(--blue);
    border-color: var(--blue);
    color: var(--white);
    z-index: 2;
  }
  .week li.selected span {
    color: white;
  }
  .week li.holiday {
    color: #fa7575;
  }
  .week li.none {
    color: var(--border);
  }
  .week a + .info {
    display: block;
    width: 100%;
    font-size: 0.875rem;
    color: var(--gray);
  }

  .top .week {
    font-size: var(--14px);
    color: #949db2;
  }
  .middle li {
    padding: 0;
  }
  .middle .week {
    font-size: var(--18px);
  }
  .middle .week li a {
    margin: 2px 0;
  }
`;

export default Week;
